<template>
    <div class="homeHeader xy-center">
        <div class="container xy-between">
            <div class="left jf">
                <img :src="logo" alt="logo" v-if="logo"/>
                <img :src="require('@/assets/img/headerLogo.png')" alt="logo" v-else/>
                <div class="jf ">
                    <div class="font-size22 text">{{orgName}}</div>
                    <div class="dote"></div>
                    <div class="font-size22 text">{{platformName}}</div>
                </div>
            </div>
            <div class="right ">
                <div class="userInfoBox xy-center">
                    <div v-if="!isShowUserName" class="userInfo jf">
                        <div class="avtor"></div>
                        <div class="loginText font-size14 c-2F3134" @click="loginBtn">
                            <span>登录</span>
                            <span>/</span>
                            <span>注册</span>
                        </div>
                    </div>
                    <div v-else class="userInfo jf  userInfoHaveLogin">
                        <div class="avtor">
                            <img :src="require('@/assets/img/defaulteActor.png')" alt="">
                        </div>
                        <div class="loginText font-size16 c-2F3134">
                            <div class="UserName one-wrap font-size14">
                                {{isPhoneNumber(userInfo.UserName)}}
<!--                                <i class="el-icon-caret-bottom"></i>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ExamHeader",
    props: {
        state: {
            type: String,
            default: ""
        }
    },
    data(vm) {
        return {
            isShowHeader: true,
            userInfo: vm.$store.state.userInfo || {},
            isShowUserName: false
        }
    },
    computed: {
        orgName({ userInfo }) {
            return userInfo.OrganName || this.$store.state.groupInfo.Name || "朗润数据"
        },
        platformName({ userInfo }) {
            return userInfo.PlatformName || this.$store.state.groupInfo.PlatformName || "医学培训考试服务平台"
        },
        logo ({ userInfo }) {
            return userInfo.Logo || this.$store.state.groupInfo.GroupUserLogo
        }
    },
    watch: {
        state(val) {
            this.userInfo = JSON.parse(val)
            this.isShowUserName = true
        }
    },
    created() {
        this.judgeIsLogin()
    },
    mounted() {
    },
    methods: {
        judgeIsLogin() {
            let info = this.$store.state.userInfo
            if (!info) {
                return
            }
            if (info === "null") {
                this.isShowUserName = false
            } else {
                this.isShowUserName = true
                this.userInfo = info
            }
        },
        loginBtn() {
            this.$emit("openLoginDiolog")
        },
        isPhoneNumber(tel) {
            let reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/;
            if (reg.test(tel)) {
                tel = tel.substr(0, 3) + "****" + tel.substr(7)
                return tel
            } else {
                return tel
            }
        }
    }
}

</script>

<style scoped lang="less">
.homeHeader {
    width: 100%;
    height: 70px;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    background:white;
    box-shadow: rgb(204, 204, 204) 1px 1px 11px;

    .container {
        width: 62.5%;

        .left {
            img {
                width: 25px;
                margin-right: 10px;
            }

            .dote {
                background-color: white;
            }

            .text {
                font-size: 22px;
                font-weight: 600;
            }
        }

        .right {
            width: 550px;
            color: white;
            display: flex;
            justify-content: flex-end;

            .ulDeltDote {
                padding: 0;
                width: 300px;
                display: flex;
                margin-right: 60px;

                li {
                    cursor: pointer;
                    height: 30px;
                    width: 80px;
                }

                li:not(:first-child) {
                    margin-left: 40px;
                }

                .shouye {
                    color: #256CF4;

                    .line {
                        width: 20px;
                        height: 6px;
                        background: #256CF4;
                        border-radius: 3px;
                    }
                }
            }

            .userInfoBox {
                width: 250px;
            }

            .userInfo {
                .avtor {
                    margin-right: 5px;
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    background: #EFEFEF;
                    border: 1px solid #FFFFFF;

                    img {
                        width: 100%;
                    }
                }

                .loginText {
                    //cursor: pointer;
                }

                .UserName {
                    max-width: 200px;
                }
            }

            .userInfoHaveLogin {
                position: relative;
                height: 80%;

                .toPersonCenter {
                    display: none;
                    width: 140px;
                    background-color: white;
                    position: absolute;
                    top: 45px;
                    right: 0;
                    border-radius: 6px;

                    .centerTextBtn {
                        width: 100%;
                        height: 40px;
                        padding: 10px;
                        box-sizing: border-box;
                        border-bottom: 1px solid #F0F3F7;

                        i {
                            margin-right: 10px;
                        }
                    }

                    .centerTextBtn:hover {
                        background-color: #F0F3F7;
                    }

                    .logOutbtn {
                        width: 100%;
                        height: 40px;
                        padding: 10px;
                        box-sizing: border-box;

                        i {
                            margin-right: 10px;
                        }
                    }

                    .logOutbtn:hover {
                        background-color: #F0F3F7;
                    }
                }
            }

            .userInfoHaveLogin:hover .toPersonCenter {
                display: block;
                box-shadow: 0px 2px 40px 0px rgba(229, 232, 236, 0.8);
            }
        }
    }
}

</style>
